import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.688 4.875a.875.875 0 1 1 1.75 0v14.25a.875.875 0 0 1-1.75 0zM15.563 4.875a.875.875 0 0 1 1.75 0v14.25a.875.875 0 0 1-1.75 0z"
  }));
}
var IcPause = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPause));

export { IcPause as I };
